import * as React from "react";

type PropsDoNotMountComponent = { sms: string; log?: unknown };

const DoNotMountComponent: React.FC<PropsDoNotMountComponent> = (props: PropsDoNotMountComponent) => {
  if (process.env.GATSBY_ENV !== "development") return <></>;
  // eslint-disable-next-line no-console
  console.log(`DoNotMountComponent ${props.sms} `, props.log);

  return (
    <section className={"o-do-not-mount-component"}>
      <div className={"c-do-not-mount-component"}>
        <p>{props.sms}</p>
      </div>
    </section>
  );
};

export default DoNotMountComponent;
1;
